import { Reveal, MaskLine } from "@/components/Reveal";
import Marquee from "react-fast-marquee";

export const EditorialIntro = () => (
  <section id="leistungen" data-testid="editorial-intro" className="relative py-32 sm:py-48 border-t border-white/5">
    <div className="max-w-screen-2xl mx-auto px-6 sm:px-10">
      <Reveal>
        <p className="label mb-10">Studio</p>
      </Reveal>
      <h2 className="font-serif font-light leading-[1.02] text-4xl sm:text-6xl lg:text-7xl tracking-tight uppercase max-w-5xl">
        <MaskLine>Von der ersten Idee</MaskLine>
        <MaskLine delay={0.08}>bis zur fertigen</MaskLine>
        <MaskLine delay={0.16} className="text-[#d4c4a8] italic">Kampagne.</MaskLine>
      </h2>
      <div className="mt-16 grid lg:grid-cols-12 gap-10">
        <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7">
          <p className="font-body text-lg sm:text-xl text-[#a1a1aa] leading-relaxed">
            Wir verbinden kreative Produktion, Content und strategische Werbung unter einem Dach.
            Vom Konzept über die Kamera bis zur Distribution entsteht alles an einem Ort — mit einem
            Partner, der die gesamte Reise mitdenkt. Kein Übersetzen zwischen Agenturen, keine Reibungsverluste.
            Nur Bilder, die eine Marke tragen.
          </p>
        </Reveal>
      </div>
    </div>

    <div className="mt-28 border-y border-white/5 py-8">
      <Marquee speed={38} gradient={false} autoFill>
        {["Videoproduktion", "Filmproduktion", "Content", "Performance Marketing", "Brand Films", "Postproduktion", "Eventproduktion", "Webdesign"].map((w, i) => (
          <span key={i} className="font-serif text-4xl sm:text-6xl italic mx-10 text-[#1f1f1f]">
            {w} <span className="text-[#d4c4a8] not-italic">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);
